var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[(_vm.xsScreen || (_vm.xsOrSmAsMobile && _vm.xsSmScreen))?_vm._t("table-mobile"):_vm._t("table")],2)}
var staticRenderFns = []

export { render, staticRenderFns }